export const AuditEvents = {
  en: {
    'Audit Log': 'Audit log',
    From: 'From (inclusive)',
    Till: 'Till (inclusive)',
    Actor: 'Actor',
    Action: 'Action',
    Category: 'Category',
    Target: 'Target',
    'Target Type': 'Target type',
    'System user': 'System user',
    'System user hint': 'Performed by the platform.',
    Details: 'Details',
    Changes: 'Changes',
    Items: 'Items',
    'Related objects': 'Related objects',
    'No changes': 'No changes recorded',
    'History of': 'History of',
    'Show all': 'Show all',
  },
  uk: {
    'Audit Log': 'Журнал дій',
    From: 'Починаючи з (включно)',
    Till: 'До (включно)',
    Actor: 'Виконавець',
    Action: 'Дія',
    Category: 'Категорія',
    Target: "Об'єкт",
    'Target Type': "Тип об'єкта",
    'System user': 'Системний користувач',
    'System user hint': 'Виконано платформою.',
    Details: 'Деталі',
    Changes: 'Зміни',
    Items: 'Позиції',
    'Related objects': "Пов'язані об'єкти",
    'No changes': 'Змін не зафіксовано',
    'History of': 'Історія',
    'Show all': 'Показати все',
  },
};
